import { Box, Button, Divider, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import bgImage from '../../assets/background/login_bg.png';
import bgImageAdmin from '../../assets/background/login_admin_bg.jpg';
import { BoxContentAuth } from './element';
import StateComponents from '../../components/state-component/StateComponents';
import PersonIcon from '@mui/icons-material/Person';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { AuthApi, loginType, registerType } from '../../api/auth/auth.api';
import { setTokenMember, validateEmail } from '../../utils/app.utils';
import { Link, useSearchParams } from 'react-router-dom';
import { routeName } from '../../routes/routeName';
import { alertError, alertSuccess } from '../../components/alert/swal';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../store/loading/loading.slice';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
import { colors } from '../../constants/colors';
import OtpInput from 'react-otp-input';
import { useTranslation } from 'react-i18next';
import { languageEnum } from '../../constants/enum';


type loginProps = { email: string, password: string };
type Props = {
    mode?: "ADMIN" | "MEMBER";
    form?: loginProps;
    setForm?: React.Dispatch<React.SetStateAction<loginProps>>;
    handleSubmit?: () => void;
    otp_data?: {
        ref: string;
        email: string;
    }
}

enum OPTION_DATA {
    LOGIN = "LOGIN",
    REGISTER = "REGISTER",
    RESET_PASSWORD = "RESET_PASSWORD",
    OTP_RESET_PASSWORD = "OTP_RESET_PASSWORD"

}
enum REGISTER_STATE {
    CREATE_ACCOUNT = "CREATE_ACCOUNT",
    CREATE_PASSWORD = "CREATE_PASSWORD",
    OTP = "OTP",
    OTP_RESET_PASSWORD = "OTP_RESET_PASSWORD"
}
const LoginMember: React.FC<Props> = ({ mode, form, setForm, handleSubmit }: Props) => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [searchParams] = useSearchParams();
    const isAdmin = mode === 'ADMIN';
    const language = i18n.language

    const is_signup = searchParams.get('signup');

    const [option_data, set_option_data] = useState<OPTION_DATA>(is_signup ? OPTION_DATA.REGISTER : OPTION_DATA.LOGIN);
    const [access_token_reset_password, set_access_token_reset_password] = useState<string>("");
    const [register_state, set_register_state] = useState<REGISTER_STATE>(REGISTER_STATE.CREATE_ACCOUNT);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [otp, set_otp] = useState<string>("");
    const [otp_ref, set_otp_ref] = useState<string>("");

    const [formState, setFormState] = useState<loginType>({
        email: "",
        password: ""
    })
    const [formStateRegister, setFormStateRegister] = useState<registerType>({
        email: "",
        member_last_name: "",
        member_mobile: "",
        member_name: "",
        password: ""
    })
    const [show_password_register, set_show_password_register] = useState<{ password: boolean, confirm_password: boolean }>({
        confirm_password: false,
        password: false
    })
    const [confirm_password, set_confirm_password] = useState<string>("");

    const handleChangeFormStateRegister = (field: keyof registerType, value: string) => {
        setFormStateRegister((prev) => ({ ...prev, [field]: value }))
    }
    const handleBackToHome = () => {
        set_option_data(OPTION_DATA.LOGIN);
        setFormStateRegister({ email: "", member_last_name: "", member_mobile: "", member_name: "", password: "" });
        set_otp("");
        set_otp_ref("");
        set_register_state(REGISTER_STATE.CREATE_ACCOUNT);
        set_confirm_password("");
        set_access_token_reset_password("");
        setFormState({ email: "", password: "" });
    }
    const clearErrorMessage = () => setErrorMessage("");
    const isNotValid = validateEmail(isAdmin ? (form?.email || "") : formState.email);
    const isNotValidEmailRegister = validateEmail(formStateRegister.email);


    const handleSubmitForm = async () => {
        dispatch(setLoading());
        await AuthApi.login(formState).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                // console.log(response, 'response');
                const ref_data = response?.ref;
                const email_data = response?.email;
                if (ref_data && email_data) {
                    // set_otp_data({ email: data?.data?.email, ref: data?.data?.ref })
                    set_otp_ref(ref_data);
                    set_option_data(OPTION_DATA.OTP_RESET_PASSWORD);
                    set_register_state(REGISTER_STATE.OTP_RESET_PASSWORD);
                    setFormStateRegister((prev) => ({ ...prev, email: email_data }))
                } else {
                    setTokenMember('TOKEN_MEMBER', response?.access_token);
                    alertSuccess(t("HOME_PAGE_SIGN_IN"), t("HOME_PAGE_LOGIN_SUCCESSFUL"), undefined, () => {
                        window.location.href = routeName.main.home;
                    });
                    setTimeout(() => {
                        window.location.href = routeName.main.home;
                    }, 500)
                }
            }
        }).catch((err) => {
            console.log(err)
            alertError(t("HOME_PAGE_LOGIN_FAILED"), (i18n.language === "en" && err?.response?.data?.en) || err?.response?.data?.th || "");
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    // set_otp_ref(response?.ref);
    // set_option_data(OPTION_DATA.OTP_RESET_PASSWORD);
    // set_register_state(REGISTER_STATE.OTP_RESET_PASSWORD);
    const handleSubmitFormRegister = async () => {
        if (!formStateRegister.email || !formStateRegister.member_last_name || !formStateRegister.member_mobile || !formStateRegister.member_name || !formStateRegister.password) {
            return alertError(t("HOME_PAGE_PROVIDE_COMPLETE_INFORMATION"))
        }
        dispatch(setLoading());
        await AuthApi.register(formStateRegister).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data;
                set_otp_ref(response?.ref);
                set_register_state(REGISTER_STATE.OTP);
            }
        }).catch((err) => {
            console.log(err);
            alertError(t("เกิดข้อผิดพลาด"), err?.response?.data?.message || "")
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleCreateAccountMember = async (is_change_password?: boolean) => {
        dispatch(setLoading());
        await AuthApi.validateOtp({ email: formStateRegister.email, otp: otp, ref: otp_ref }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                if (is_change_password) {
                    set_access_token_reset_password(response?.access_token);
                } else {
                    setTokenMember('TOKEN_MEMBER', response?.access_token);
                    alertSuccess(t("HOME_PAGE_CREATE_A_USER_ACCOUNT"), t("HOME_PAGE_CREATE_USER_ACCOUNT_SUCCESSFULLY"), undefined, () => {
                        window.location.href = routeName.main.home;
                    });
                    setTimeout(() => {
                        window.location.href = routeName.main.home;
                    }, 500)
                }
            }
        }).catch((err) => {
            console.log(err);
            alertError(t("เกิดข้อผิดพลาด"), err?.response?.data?.message || "")
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const changePassword = async (access_token: string) => {
        dispatch(setLoading());
        await AuthApi.password({ password: formStateRegister.password }, access_token).then((res) => {
            if (res.status < 300) {
                handleBackToHome();
                alertSuccess(t("HOME_PAGE_CHANGE_YOUR_PASSWORD"), t("HOME_PAGE_PASSWORD_CHANGED_SUCCESSFULLY"));
            }
        }).catch((err) => {
            console.log(err)
            alertError(t("HOME_PAGE_PASSWORD_CHANGE_FAILED"))
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const forgotPassword = async () => {
        dispatch(setLoading());
        await AuthApi.forgot_password({ email: formStateRegister.email }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                set_otp_ref(response?.ref);
                set_option_data(OPTION_DATA.OTP_RESET_PASSWORD);
                set_register_state(REGISTER_STATE.OTP_RESET_PASSWORD);
            }
        }).catch((err) => {
            alertError(t("HOME_PAGE_PASSWORD_RESET_FAILED"), language === languageEnum.TH ? err?.response?.data?.th : err?.response?.data?.en || t("HOME_PAGE_PLEASE_CHECK_YOUR_EMAIL_AGAIN."))
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    // useEffect(() => {
    //     if (otp_data?.ref) {
    //         // console.log(otp_data,'otp_data')
    //         set_otp_ref(otp_data?.ref);
    //         set_option_data(OPTION_DATA.OTP_RESET_PASSWORD);
    //         set_register_state(REGISTER_STATE.OTP_RESET_PASSWORD);
    //         setFormStateRegister((prev) => ({ ...prev, email: otp_data.email }))
    //     }
    // }, [otp_data])




    return (
        <Box sx={{
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundImage: `url(${isAdmin ? bgImageAdmin : bgImage
                })`
        }} className="w-full flex justify-center items-center min-h-screen">

            {option_data === OPTION_DATA.LOGIN && (
                <BoxContentAuth
                    title={t("HOME_PAGE_LOG_IN")}
                    detail={t("HOME_PAGE_LOG_IN_TO_YOUR_ACCOUNT")}
                    isAdmin={isAdmin}
                    content={
                        <Box>
                            <StateComponents
                                sxContainer={{ my: 3 }}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("อีเมล"),
                                            endAdornment: <PersonIcon />,
                                            onblur: () => {
                                                if (isAdmin) {
                                                    if (form?.email) {
                                                        if (!isNotValid) {
                                                            setErrorMessage(t("HOME_PAGE_INVALID_EMAIL_FORMAT"))
                                                        }
                                                    }
                                                } else {
                                                    if (formState.email) {
                                                        if (!isNotValid) {
                                                            setErrorMessage(t("HOME_PAGE_INVALID_EMAIL_FORMAT"))
                                                        }
                                                    }
                                                }
                                            },
                                            helperText: errorMessage,
                                            value: isAdmin ? form?.email : formState.email,
                                            placeholder: t("HOME_PAGE_PLEASE_ENTER_YOUR_EMAIL_ADDRESS."),
                                            onChange: (e) => {
                                                if (isAdmin) {
                                                    setForm?.((prev) => ({ ...prev, email: e.target.value }));
                                                } else {
                                                    setFormState((prev) => ({ ...prev, email: e.target.value }));
                                                }
                                                clearErrorMessage();
                                            },
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("HOME_PAGE_PASSWORD"),
                                            type: showPassword ? 'text' : 'password',
                                            value: isAdmin ? form?.password : formState.password,
                                            endAdornment: <IconButton onClick={() => setShowPassword((prev) => !prev)}>{showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}</IconButton>,
                                            placeholder: t("HOME_PAGE_PLEASE_ENTER_YOUR_PASSWORD."),
                                            onKeyDown: (e) => {
                                                if (isAdmin) {
                                                    if (form?.password && form.email) {
                                                        if (e.key === 'Enter') {
                                                            handleSubmit?.()
                                                        }
                                                    }
                                                } else {
                                                    if (formState?.password && formState.email) {
                                                        if (e.key === 'Enter') {
                                                            handleSubmitForm()
                                                        }
                                                    }
                                                }
                                            },
                                            onChange: (e) => isAdmin ? setForm?.((prev) => ({ ...prev, password: e.target.value })) : setFormState((prev) => ({ ...prev, password: e.target.value })),
                                        }
                                    },
                                ]}
                            />
                            <Box my={4} className="flex justify-between items-center">
                                <Link to={routeName.main.home}>
                                    <Typography className='cursor-pointer hover:underline' textAlign={"end"} >{t("HOME_PAGE_RETURN_TO_HOME_PAGE")}</Typography>
                                </Link>
                                <Typography onClick={() => set_option_data(OPTION_DATA.RESET_PASSWORD)} className='cursor-pointer hover:underline' textAlign={"end"} sx={{ color: "#F79009" }}>{t("HOME_PAGE_FORGOT_YOUR_PASSWORD?")}</Typography>
                            </Box>
                            <Divider />
                            <Button variant='contained' onClick={isAdmin ? handleSubmit : handleSubmitForm}
                                disabled={isAdmin ? (!isNotValid || !form?.email || !form?.password) : (!isNotValid || !formState.email || !formState.password)} fullWidth sx={{
                                    '&.Mui-disabled': {
                                        backgroundColor: "#dbd6d898f",
                                        color: "#fff",
                                    },
                                    backgroundColor: "#FCAF17",
                                    '&:hover': { backgroundColor: "#e0c795" }
                                }}>
                                <Typography sx={{ color: "white" }} variant='h6'>
                                    {t("HOME_PAGE_LOG_IN")}
                                </Typography>
                            </Button>

                            {!isAdmin && (
                                <Box my={2} className="flex justify-center items-center gap-4">
                                    <Typography>
                                        {t("HOME_PAGE_YOU_DON'T_HAVE_AN_ACCOUNT?")}
                                    </Typography>
                                    <Typography onClick={() => set_option_data(OPTION_DATA.REGISTER)} className='cursor-pointer hover:underline' sx={{ color: '#FCAF17' }}>
                                        {t("HOME_PAGE_CREATE_A_USER_ACCOUNT")}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    }
                />
            )}
            {[OPTION_DATA.REGISTER, OPTION_DATA.RESET_PASSWORD, OPTION_DATA.OTP_RESET_PASSWORD].includes(option_data) && (
                <BoxContentAuth
                    isAdmin={isAdmin}
                    detail={option_data === OPTION_DATA.RESET_PASSWORD ? t("HOME_PAGE_PLEASE_ENTER_YOUR_EMAIL_ADDRESS_USED_TO_REGISTER_TO_RESET_YOUR_PASSWORD.") : t("HOME_PAGE_PLEASE_PROVIDE_COMPLETE_INFORMATION.")}
                    title={option_data === OPTION_DATA.OTP_RESET_PASSWORD ? t("HOME_PAGE_RESET_PASSWORD") : OPTION_DATA.RESET_PASSWORD === option_data ? t('HOME_PAGE_RESET_PASSWORD') : t("HOME_PAGE_CREATE_A_USER_ACCOUNT")}
                    content={
                        <>
                            {REGISTER_STATE.CREATE_ACCOUNT === register_state && OPTION_DATA.REGISTER === option_data && (
                                <Box className="flex flex-col justify-between items-center gap-10">
                                    <StateComponents
                                        otherProps={{ spacing: 2 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    heading: t("HOME_PAGE_NAME"),
                                                    endAdornment: <PersonIcon />,
                                                    placeholder: t("HOME_PAGE_PLEASE_STATE_YOUR_NAME."),
                                                    value: formStateRegister.member_name,
                                                    onChange: (e) => {
                                                        handleChangeFormStateRegister('member_name', e.target.value)
                                                    },
                                                }
                                            },
                                            {
                                                seq: 2,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    heading: t("HOME_PAGE_SURNAME"),
                                                    value: formStateRegister.member_last_name,
                                                    onChange: (e) => {
                                                        handleChangeFormStateRegister('member_last_name', e.target.value)
                                                    },
                                                    endAdornment: <PersonIcon />,
                                                    placeholder: t("HOME_PAGE_PLEASE_SPECIFY_YOUR_LAST_NAME."),
                                                }
                                            },
                                            {
                                                seq: 3,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    heading: t('HOME_PAGE_EMAIL'),
                                                    value: formStateRegister.email,
                                                    onChange: (e) => {
                                                        handleChangeFormStateRegister('email', e.target.value)
                                                    },
                                                    endAdornment: <EmailIcon />,
                                                    placeholder: t("HOME_PAGE_PLEASE_ENTER_YOUR_EMAIL_ADDRESS."),
                                                }
                                            },
                                            {
                                                seq: 4,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    endAdornment: <CallIcon />,
                                                    heading: t("HOME_PAGE_TELEPHONE_NUMBER"),
                                                    placeholder: t("HOME_PAGE_PLEASE_PROVIDE_YOUR_PHONE_NUMBER."),
                                                    value: formStateRegister.member_mobile,
                                                    onChange: (e) => {
                                                        handleChangeFormStateRegister('member_mobile', e.target.value)
                                                    },
                                                }
                                            },
                                        ]}
                                    />

                                    <Button
                                        onClick={() => set_register_state(REGISTER_STATE.CREATE_PASSWORD)}
                                        sx={{ backgroundColor: colors.subPrimary }}
                                        disabled={!formStateRegister.email || !formStateRegister.member_last_name || !formStateRegister.member_name || !isNotValidEmailRegister} fullWidth variant='contained'>
                                        {t('HOME_PAGE_NEXT')}
                                    </Button>

                                    <Typography className='cursor-pointer hover:underline' onClick={() => {
                                        set_option_data(OPTION_DATA.LOGIN);
                                        setFormStateRegister({ email: "", member_last_name: "", member_mobile: "", member_name: "", password: "" });
                                        set_register_state(REGISTER_STATE.CREATE_ACCOUNT);
                                    }} fontWeight={600}>
                                        {t("HOME_PAGE_RETURN_TO_THE_LOGIN_PAGE")}
                                    </Typography>
                                </Box>
                            )}
                            {((REGISTER_STATE.CREATE_PASSWORD === register_state && OPTION_DATA.REGISTER === option_data) || access_token_reset_password) && (
                                <Box className="flex flex-col justify-between h-full gap-10">
                                    <Box>
                                        <StateComponents
                                            otherProps={{ spacing: 2 }}
                                            typeProps={[
                                                {
                                                    seq: 1,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12
                                                    },
                                                    fieldProps: {
                                                        type: show_password_register.password ? 'text' : "password",
                                                        heading: t("HOME_PAGE_PASSWORD"),
                                                        placeholder: t("HOME_PAGE_PLEASE_ENTER_YOUR_PASSWORD."),
                                                        endAdornment: <IconButton onClick={() => set_show_password_register((prev) => ({ ...prev, password: !prev.password }))}>{show_password_register.password ? <VisibilityIcon /> : <VisibilityOffIcon />}</IconButton>,
                                                        value: formStateRegister.password,
                                                        onChange: (e) => handleChangeFormStateRegister('password', e.target.value),
                                                    }
                                                },
                                                {
                                                    seq: 2,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12
                                                    },
                                                    fieldProps: {
                                                        type: show_password_register.confirm_password ? 'text' : "password",
                                                        heading: t("HOME_PAGE_CONFIRM_PASSWORD"),
                                                        placeholder: t("HOME_PAGE_PLEASE_CONFIRM_YOUR_PASSWORD_AGAIN."),
                                                        endAdornment: <IconButton onClick={() => set_show_password_register((prev) => ({ ...prev, confirm_password: !prev.confirm_password }))}>{show_password_register.confirm_password ? <VisibilityIcon /> : <VisibilityOffIcon />}</IconButton>,
                                                        value: confirm_password,

                                                        helperText: (formStateRegister.password !== confirm_password && formStateRegister.password && confirm_password) ? t("HOME_PAGE_PASSWORDS_DO_NOT_MATCH") : undefined,
                                                        onChange: (e) => set_confirm_password(e.target.value),
                                                    }
                                                },
                                            ]}
                                        />
                                        <Typography mt={3} sx={{
                                            fontSize: "12px",
                                            color: '#828282'
                                        }} fontWeight={300}>
                                            {t("HOME_PAGE_PASSWORD_OF_8_OR_MORE_CHARACTERS,_CONSISTING_OF_LETTERS_AND_NUMBERS.")}
                                        </Typography>
                                    </Box>
                                    <Box className="flex flex-col gap-4">
                                        <Button
                                            onClick={() => access_token_reset_password ? changePassword(access_token_reset_password) : handleSubmitFormRegister()}
                                            sx={{ backgroundColor: colors.subPrimary }}
                                            disabled={((!formStateRegister.email
                                                || !formStateRegister.member_last_name
                                                || !formStateRegister.member_mobile
                                                || !formStateRegister.member_name)
                                                || (formStateRegister.password !== confirm_password)
                                                || !formStateRegister.password) && !access_token_reset_password
                                            }
                                            fullWidth
                                            variant='contained'>
                                            {t("HOME_PAGE_NEXT")}
                                        </Button>
                                        <Typography textAlign={"center"} className='cursor-pointer hover:underline' onClick={() => {
                                            set_option_data(OPTION_DATA.LOGIN);
                                            setFormStateRegister({ email: "", member_last_name: "", member_mobile: "", member_name: "", password: "" });
                                            set_register_state(REGISTER_STATE.CREATE_ACCOUNT);
                                            set_confirm_password("");
                                        }} fontWeight={600}>
                                            {t('HOME_PAGE_RETURN_TO_THE_LOGIN_PAGE')}
                                        </Typography>
                                    </Box>
                                </Box>
                            )}
                            {([REGISTER_STATE.OTP, REGISTER_STATE.OTP_RESET_PASSWORD].includes(register_state)) && [OPTION_DATA.REGISTER, OPTION_DATA.OTP_RESET_PASSWORD].includes(option_data) && !access_token_reset_password && (
                                <Box className="w-full justify-between items-center h-full flex-col py-10 flex">
                                    <Box>
                                        <Typography textAlign={"center"} sx={{ color: "#7A7F89" }}>
                                            {t("HOME_PAGE_PLEASE_CHECK_YOUR_EMAIL,_WE_HAVE_SENT_AN_OTP_CODE_TO_YOU.")}
                                        </Typography>
                                        <Box className="flex justify-center items-center gap-4">
                                            <Typography sx={{ color: colors.subPrimary }}>{formStateRegister.email}</Typography>
                                            <Typography sx={{ color: "#7A7F89" }}> ref. {otp_ref}</Typography>
                                        </Box>
                                        <Box my={2} className="w-full justify-center items-center flex">
                                            <OtpInput
                                                value={otp}
                                                onChange={(val) => {
                                                    const onlyNumbers = val.replace(/\D/g, '');
                                                    set_otp(onlyNumbers);
                                                }}
                                                numInputs={6}
                                                shouldAutoFocus
                                                renderSeparator={<span style={{ width: "12px" }}></span>}
                                                renderInput={(props) => (
                                                    <input
                                                        {...props}
                                                        maxLength={1}
                                                        onKeyPress={(e) => {
                                                            if (!/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        style={{
                                                            width: "56px",
                                                            height: "56px",
                                                            borderRadius: "12px",
                                                            border: "1px solid #ccc",
                                                            textAlign: "center",
                                                            fontSize: "16px",
                                                            fontWeight: 500,
                                                            caretColor: "#1976d2",
                                                            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                                            outline: "none",
                                                        }}
                                                    />
                                                )}
                                            />

                                        </Box>
                                    </Box>
                                    <Box className="h-full w-full flex justify-end items-center flex-col gap-4">
                                        <Button
                                            onClick={() => option_data === OPTION_DATA.OTP_RESET_PASSWORD ? handleCreateAccountMember(true) : handleCreateAccountMember()}
                                            sx={{ backgroundColor: colors.subPrimary }}
                                            disabled={!formStateRegister.email
                                                // || !formStateRegister.member_last_name
                                                // || !formStateRegister.member_mobile
                                                // || !formStateRegister.member_name)
                                                // || (formStateRegister.password !== confirm_password)
                                                // || !formStateRegister.password
                                                || otp.length !== 6
                                            }
                                            fullWidth
                                            variant='contained'>
                                            {t("HOME_PAGE_CONFIRM")}
                                        </Button>
                                        <Typography textAlign={"center"} className='cursor-pointer hover:underline' onClick={handleBackToHome} fontWeight={600}>
                                            {t('HOME_PAGE_RETURN_TO_THE_LOGIN_PAGE')}
                                        </Typography>
                                    </Box>
                                </Box>
                            )}
                            {OPTION_DATA.RESET_PASSWORD === option_data && (
                                <Box className="w-full h-full flex flex-col justify-between items-center">
                                    <Box className="w-full">
                                        <StateComponents
                                            sxContainer={{ my: 2 }}
                                            typeProps={[
                                                {
                                                    seq: 1,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12
                                                    },
                                                    fieldProps: {
                                                        heading: t("HOME_PAGE_EMAIL"),
                                                        value: formStateRegister.email,
                                                        onChange: (e) => {
                                                            handleChangeFormStateRegister('email', e.target.value)
                                                        },
                                                        endAdornment: <PersonIcon />,
                                                        placeholder: t("HOME_PAGE_PLEASE_ENTER_YOUR_EMAIL_ADDRESS."),
                                                    }
                                                },
                                            ]}
                                        />
                                    </Box>
                                    <Box className="w-full flex flex-col gap-4 justify-center items-center">
                                        <Button
                                            onClick={forgotPassword}
                                            sx={{ backgroundColor: colors.subPrimary }}
                                            disabled={!formStateRegister.email || !isNotValidEmailRegister} fullWidth variant='contained'>
                                            {t("HOME_PAGE_CONFIRM")}
                                        </Button>

                                        <Typography className='cursor-pointer hover:underline' onClick={() => {
                                            set_option_data(OPTION_DATA.LOGIN);
                                            setFormStateRegister({ email: "", member_last_name: "", member_mobile: "", member_name: "", password: "" });
                                            set_register_state(REGISTER_STATE.CREATE_ACCOUNT);
                                            set_confirm_password("");
                                        }} fontWeight={600}>
                                            {t("HOME_PAGE_RETURN_TO_THE_LOGIN_PAGE")}
                                        </Typography>
                                    </Box>
                                </Box>
                            )}
                        </>
                    }
                />
            )}
        </Box >
    )
}

export default LoginMember